module.exports = __webpack_public_path__ + "static/media/12.d710a3ac.jpg";